<script>
  import ActionsDropdown from "@/core/components/ActionsDropdown"
  import ResponsiveTable from "@/core/components/table/ResponsiveTable"
  import { faEye, faEdit, faTrash } from "@fortawesome/free-solid-svg-icons"
  import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome"
  import { lowerCase } from "lodash"
  import { dateFormat } from "@/core/services/helpers"
  import _isEqual from "lodash/isEqual"
  import Modal from "@/core/components/NewModal.vue"

  export default {
    components: {
      ResponsiveTable,
      FontAwesomeIcon,
      ActionsDropdown,
      Modal,
    },
    data: () => {
      return {
        faEye,
        faEdit,
        faTrash,
        dateFormat,
        title: "Linhas",
        crumbs: [
          { name: "Início", path: "index" },
          { name: "Linhas", path: "lines.index" },
          {
            name: "Sazonalidades",
            path: "lines.seasonality.seasonalities",
          },
        ],
        data: [],
        loading: false,
        status: "pending",
        headers: [
          { text: "Número", value: "idsazonalidade", order: true },
          { text: "Nome", value: "desazonalidade", order: true },
          { text: "Início", value: "dtinicio", order: true },
          { text: "Fim", value: "dtfim", order: true },
          "",
        ],
        currentOrder: 1,
        orderOptions: [
          {
            id: 0,
            order: { idsazonalidade: "ASC" },
          },
          {
            id: 1,
            order: { idsazonalidade: "DESC" },
          },
          {
            id: 2,
            order: { desazonalidade: "ASC" },
          },
          {
            id: 3,
            order: { desazonalidade: "DESC" },
          },
          {
            id: 4,
            order: { dtinicio: "ASC" },
          },
          {
            id: 5,
            order: { dtinicio: "DESC" },
          },
          {
            id: 6,
            order: { dtfim: "ASC" },
          },
          {
            id: 7,
            order: { dtfim: "DESC" },
          },
        ],
        pagination: {},
        page: 1,
        toBeDeleted: null,
        filters: {
          desazonalidade: "",
          dtinicio: "",
          dtfim: "",
          flstatus: true,
        },
      }
    },
    computed: {
      order() {
        let order = this.orderOptions.find(
          (i) => i.id === this.currentOrder
        ).order
        if (order) {
          return order
        }
        return {}
      },
    },
    watch: {
      origin: function () {
        this.page = 1
        this.getSeasonalities()
      },
    },
    mounted() {
      this.getSeasonalities()
    },
    methods: {
      capitalize(string) {
        let arrayPalavras = string.split(" ")
        let arrayPalavrasCapitalized = arrayPalavras.map((palavra) => {
          return palavra.charAt(0).toUpperCase() + lowerCase(palavra.slice(1))
        })
        return arrayPalavrasCapitalized.join(" ")
      },
      getSeasonalities(filters) {
        if (filters) {
          this.filters = filters
          this.filters.flstatus = true
        }
        try {
          this.status = "pending"
          this.$Progress.start()
          this.loading = true
          this.$axios
            .post("/api/lines/seasonality/search?page=" + this.page, {
              orderBy: this.order,
              filters: this.filters,
            })
            .then((response) => {
              this.data = response.data.data
              this.pagination = response.data
              delete this.pagination.data
              this.loading = false
              this.status = "finished"
              this.$Progress.finish()
            })
        } catch (e) {
          this.loading = false
          this.status = "rejected"
          this.$Progress.finish()
        }
      },
      editSeasonality(seasonality) {
        this.$router.push({
          name: "lines.seasonalities.edit",
          params: { id: seasonality.idsazonalidade },
        })
      },
      inativateSeasonality() {
        this.$axios
          .post(
            "/api/lines/seasonality/inativate/" +
              this.toBeDeleted.idsazonalidade
          )
          .then(() => {
            this.getSeasonalities()
            this.$refs.inativateSeasonalityModal.hide()
            this.$toast.success({
              title: "OK",
              message: "Sazonalidade excluída com sucesso",
            })
          })
          .catch((error) => {
            this.$toast.error({
              title: "Erro",
              message: error.response.data.error,
            })
          })
      },
      toggleModal(seasonality) {
        this.toBeDeleted = seasonality
        if (this.$refs.inativateSeasonalityModal.open) {
          this.$refs.inativateSeasonalityModal.hide()
        } else {
          this.$refs.inativateSeasonalityModal.show()
        }
      },
      changePage(page) {
        if (page !== this.page && this.status !== "pending") {
          this.page = page
          this.getSeasonalities()
        }
      },
      dataList(data) {
        if (data.length > 0) {
          return data.map((item) => {
            return {
              idsazonalidade: item.idsazonalidade,
              desazonalidade: item.desazonalidade,
              dtinicio: item.dtinicio,
              dtfim: item.dtfim,
            }
          })
        }
        return []
      },
      updateSorting(sort) {
        let order = this.orderOptions.find((i) => _isEqual(i.order, sort))
        if (order) {
          this.currentOrder = order.id
          this.reload()
        }
      },
      reload() {
        this.page = 1
        this.getSeasonalities()
      },
    },
  }
</script>

<template>
  <div>
    <portal-target name="modals"/>
    <Modal
      ref="inativateSeasonalityModal"
      content-class="px-4 pt-5"
      :close-on-click-outside="true"
    >
      <h1 class="text-center mb-7 text-lg">Excluir Sazonalidade</h1>
      <div class="px-4 mb-7">
        <h2 class="mb-2">
          Essa alteração afetará diretamente as linhas regulares.
        </h2>
        <p class="mb-10">Deseja realmente excluir a sazonalidade?</p>
        <div class="flex justify-end mb-0">
          <button
            class="btn-secondary rounded-none uppercase px-2 py-1 w-8"
            @click="toggleModal"
          >
            Cancelar
          </button>
          <button class="form-red px-2 py-1 w-24" @click="inativateSeasonality">
            Excluir
          </button>
        </div>
      </div>
    </Modal>
    <ResponsiveTable
      :headers="headers"
      :data="data"
      :disabled="loading"
      :pagination="pagination"
      :has-pagination="true"
      :status="status"
      :sorting="true"
      :sorted-header="order"
      @sort="updateSorting"
      @changePage="
                (page) => {
                    changePage(page);
                }
            "
    >
      <template #row="props">
        <td :class="props.tdClass" class="text-xs p-3 w-1/6">
          {{ props.row.idsazonalidade }}
        </td>
        <td :class="props.tdClass" class="text-xs p-3 w-1/4">
          {{ props.row.desazonalidade }}
        </td>
        <td :class="props.tdClass" class="text-xs p-3 w-1/4">
          {{ dateFormat(props.row.dtinicio) }}
        </td>
        <td :class="props.tdClass" class="text-xs p-3 w-1/4">
          {{ dateFormat(props.row.dtfim) }}
        </td>
        <td :class="props.tdClass" class="w-1/4">
          <div class="flex items-baseline">
            <div
              class="text-green-base cursor-pointer mr-2"
              title="Excluir Sazonalidade"
              @click="toggleModal(props.row)"
            >
              <FontAwesomeIcon :icon="faTrash"></FontAwesomeIcon>
            </div>
            <div
              class="text-green-base cursor-pointer"
              title="Editar Sazonalidade"
              @click="editSeasonality(props.row)"
            >
              <FontAwesomeIcon :icon="faEdit"></FontAwesomeIcon>
            </div>
          </div>
        </td>
      </template>
      <template #responsive="props">
        <tr>
          <th :class="props.thClass">Nome</th>
          <td :class="props.tdClass + ' relative'">
            <ActionsDropdown class="absolute right-0 top-0">
              <template slot="actions">
                <div
                  class="block hover:text-white text-gray-800 px-4 py-2 hover:bg-green-500 w-full text-left"
                  title="Visualizar horários"
                  @click="viewSeasonality(props.row)"
                >
                  Visualizar horários
                </div>
                <div
                  class="block hover:text-white text-gray-800 px-4 py-2 hover:bg-green-500 w-full text-left"
                  title="Editar Sessão"
                  @click="editSeasonality(props.row)"
                >
                  Editar Sessão
                </div>
              </template>
            </ActionsDropdown>
            {{ props.row.desazonalidade }}
          </td>
        </tr>
        <tr>
          <th :class="props.thClass">Início</th>
          <td :class="props.tdClass">{{ dateFormat(props.row.dtinicio) }}</td>
        </tr>
        <tr>
          <th :class="props.thClass">Fim</th>
          <td :class="props.tdClass">{{ dateFormat(props.row.dtfim) }}</td>
        </tr>
      </template>
    </ResponsiveTable>
  </div>
</template>
